import React, {useEffect, useState} from 'react';
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import {getPaymentModesQuery} from "../../../gql/PaymentModesGql";
import {getRhPeoplesQuery} from "../../../gql/RhPeopleGql";
import useAuth from "../../../hooks/useAuth";
import {Grid, TextField} from "@mui/material";
import {getStaffsQuery, updateStaffMutation} from "../../../gql/StaffGql";
import localStrings from "../../../localStrings";
import {AutoComplete} from "antd";
import {Autocomplete} from "@mui/lab";
import enqueueSnackbarWithSound from "../../../utils/SnackBarWithSound";
import toast from "react-hot-toast";
import useSettings from "../../../hooks/useSettings";
import useSound from "use-sound";
import config from "../../../conf/config.json";

function RhMapping() {
    const [playDone] = useSound(
        config.sound.done,
        { volume: 0.5 }
    );

    const [rhPeoples, setRhPeoples] = useState([]);
    const [staffs, setStaffs] = useState([]);
    const { playSoundIfActive } = useSettings()
    const {currentBrand, currentEstablishment} = useAuth();
    useEffect(() => {
        if (!currentBrand() || !currentEstablishment()) {
            return;
        }
        const loadData = async () => {
            var res = await executeQueryUtil(
                getRhPeoplesQuery(currentBrand().id, currentEstablishment().id));
            setRhPeoples(res?.data?.getRhPeoples);

            res = await executeQueryUtil(
                getStaffsQuery(currentBrand().id, currentEstablishment().id));
            setStaffs(res?.data?.getStaffs);
        }
        loadData();

    }, [currentBrand(), currentEstablishment()]);

    function sortStaff() {
        let ret =  [...(staffs || [])];
        return ret.sort((a, b) => {
            return a.name.localeCompare(b.name);
        })
    }

    return (
        <div style={{width: '100%'}}>
            <Grid container spacing={2}>
                {sortStaff().map((staff, index) => {
                    return (
                        <>
                            <Grid
                                item
                                xs={6}
                            >
                                {/*<TextField*/}
                                {/*    disabled={true}*/}
                                {/*    fullWidth*/}
                                {/*    value={staff.name}*/}
                                {/*/>*/}
                                <p>{staff.name}</p>
                            </Grid>

                            <Grid
                                xs={6}
                                item
                            >
                                <Autocomplete
                                    disablePortal
                                    getOptionLabel={
                                        (rhPeople) => {
                                            return rhPeople.fullName;
                                        }
                                    }
                                    options={rhPeoples}
                                    value={rhPeoples.find(rhPeople => rhPeople.id === staff.rhId)}
                                    onChange={async  (event, value) => {
                                        const resUpdate = await executeMutationUtil(
                                            updateStaffMutation(currentBrand().id, currentEstablishment().id, {
                                                ...staff,
                                                rhId : value.id,
                                            }));


                                            setStaffs(
                                                [
                                                    ...staffs.filter(staff => staff.id !== resUpdate.data.updateStaff.id),
                                                    resUpdate.data.updateStaff
                                                ],

                                            );


                                        enqueueSnackbarWithSound(toast, playDone, playSoundIfActive, localStrings.notif.rhAssociationDone);
                                    }}
                                    // sx={{ width: 300 }}
                                    renderInput={(params) =>
                                        <TextField {...params} label={localStrings.rhPeople} />}
                                />
                            </Grid>
                        </>
                    )
                })}
            </Grid>
        </div>
    )
}

export default RhMapping